import { Alert } from "@productlane/ui"

import { useTrial } from "@/lib/useTrial"
import { SettingsContainer } from "@/screens/settings/settings-switches/settings-container"
import { SettingsHeader } from "../../settings-header"
import { ImportPortalBadge } from "../import-portal"
import { DocsCsvUploadField } from "./steps/docs-csv-upload-field"

export function DocsCsvImportPage() {
	const { hasTrialEnded } = useTrial()

	return (
		<>
			<SettingsHeader
				title="Docs CSV import"
				subtitle={null}
				titleSuffix={<ImportPortalBadge />}
			/>
			{!hasTrialEnded ? (
				<SettingsContainer>
					<DocsCsvUploadField />
				</SettingsContainer>
			) : (
				<Alert variant="warning">Trial ended. Upgrade to import data.</Alert>
			)}
		</>
	)
}
